export const GRAPH_PERIOD_TYPE = {
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
  CUSTOM: "custom",
}
